module.exports = __webpack_public_path__ + "static/media/2.6093ab51.JPG";